import { render, staticRenderFns } from "./DuwaEditModal.vue?vue&type=template&id=6602f086"
import script from "./DuwaEditModal.vue?vue&type=script&lang=js"
export * from "./DuwaEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports